import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../../../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../ui/dialog";

/**
 * "Copiază pentru dezvoltare" (14.10.2026): the tickets as Markdown, into the
 * clipboard. Safari only lets a page write there inside the click itself, so
 * the text is handed over as a promise when the browser takes one; where the
 * clipboard refuses anyway, the text opens in a window to copy by hand.
 * Returns `[copy(ids), element]`; render the element once.
 */
export default function useDevCopy() {
  const [text, setText] = useState("");
  const area = useRef(null);

  const copy = async (ids) => {
    const fetching = api.post("/admin/tickets/export", { ids }).then((r) => r.data.markdown);
    const done = () => toast.success(ids.length === 1 ? "Tichetul a fost copiat. Lipește-l în conversația de dezvoltare."
      : `${ids.length} tichete copiate. Lipește-le în conversația de dezvoltare.`);
    try {
      if (window.ClipboardItem && navigator.clipboard?.write) {
        await navigator.clipboard.write([new window.ClipboardItem({
          "text/plain": fetching.then((t) => new Blob([t], { type: "text/plain" })),
        })]);
      } else {
        await navigator.clipboard.writeText(await fetching);
      }
      done();
    } catch (err) {
      try {
        setText(await fetching);
      } catch (apiErr) {
        toast.error(apiErrorMessage(apiErr, "Tichetele nu au putut fi copiate."));
      }
    }
  };

  const element = (
    <Dialog open={Boolean(text)} onOpenChange={(v) => { if (!v) setText(""); }}>
      <DialogContent className="max-w-2xl" data-testid="ticket-copy-fallback"
        onOpenAutoFocus={(e) => { e.preventDefault(); area.current?.select(); }}>
        <DialogHeader>
          <DialogTitle>Copiază pentru dezvoltare</DialogTitle>
          <DialogDescription>
            Browserul nu a lăsat copierea automată. Textul e selectat: apasă Ctrl+C / ⌘C și lipește-l în conversația de dezvoltare.
          </DialogDescription>
        </DialogHeader>
        <textarea ref={area} readOnly value={text} rows={16}
          className="w-full px-3 py-2 text-xs font-mono bg-[#F5F6F6] border border-[#E5E7EB] rounded-lg" />
      </DialogContent>
    </Dialog>
  );

  return [copy, element];
}
